// Single source of truth for classifying a map variant / entityType in knock-status flows.
// Both the entityType payload (useClearKnockStatus) and the edit-permission gate
// (useKnockStatusEditPermission) derive from this, so a new variant is a one-line change here and
// a compile-time failure (via Record<KnockStatusVariantKind, ...>) in any consumer that forgets to
// map it -- not a silent fallback to 'lead' (SH-661).
export type KnockStatusVariantKind = 'opportunity' | 'draftLead' | 'lead'

export function classifyKnockStatusVariant(
  variantOrEntityType: string,
): KnockStatusVariantKind {
  const normalized = variantOrEntityType?.toLowerCase()
  if (normalized === 'opportunity') return 'opportunity'
  if (normalized === 'draftlead' || normalized === 'pendinglead')
    return 'draftLead'
  return 'lead'
}
